import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { routerActions } from 'connected-react-router';
import { Button } from 'react-bootstrap';
import { Form, FormControl, FormGroup, ButtonGroup } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import get from 'lodash/get';
import { isEmpty } from 'lodash';
import { DialogBox } from './../../components/shared';
import config from '../../../config';
import Loading from './Loading';
import Error from './Error';
import Quote from './Quote';
import Knockout from './Knockout';

import ToastMessage, { toastify } from './../../components/shared/Toasts';
import preferenceToastMessages from './../../user/preference/components/ToastMessages';
import {
    CHANGE_SUBMISSION,
    CHANGE_SUBMISSION_STATUS,
    SUBMISSION_STATUS
} from '../../constants/submission';

import { savePreferences, doNotSetPreference, removePreferences } from './../../user';

import * as utils from './../../utils';
import isUnderwriter from '../../utils/is-underwriter'
import {
    changeCoverage,
    changeSubmissionStatus,
    clearSubmissionStatus,
    createRelatedSubmission,
    editSubmission,
    submissionFailed,
    changePricingValue,
    updateWorkflowStatusChange,
    updateWorkflowIncludedChange,
    updatedIsBinded,
    updatedIsBinderSaved,
    changeAIFormValues,
    changeAIList,
    loadArgopi,
} from '../../submissions/actions';

import { STATUS } from '../../constants';
import PendingStatus from './PendingStatus';
import withSubmission from '../../submissions/withSubmission';
import { validation } from '../../submissions';
import { updateSubjectivities } from '../../submissions/components/getSubjectivities';
import { updateExclusionU650 } from '../../submissions/components/getExclusionU650';
import { getItemsNeededToDesignatedContractors } from '../../submissions/components/GCList';
import { getU658DesignatedContractorsName } from '../../submissions/components/DesignatedGeneralContractor';
import { isU653Applicable } from '../../submissions/components/OptionalFormsSelector';
import featureFlags from '../../utils/featureFlags'
import { Prompt } from 'react-router-dom';

const toastErrorMessage = (
    <ToastMessage icon="exclamation">
        Something Appears to be Wrong. <br />
        Contact us through the mail icon on the bottom of the screen for assistance
    </ToastMessage>
);
export class FormResults extends Component {
    constructor(props) {
        super(props);
        const type = get(this.props.submission, 'type', 'default');
        let _90backday = new Date();
        const finish_Date = new Date(this.props.submission.anticipatedFinishDate).getTime();
        const curr_Date = new Date().getTime();
        const eff_Date = new Date(this.props.submission.anticipatedStartDate).getTime();
        _90backday = new Date().setDate(_90backday.getDate() - 91);
        const isValidEffDate = isUnderwriter(this.props.user) && ((eff_Date > _90backday) && (finish_Date > curr_Date));
        const title = isValidEffDate ? 'Submission has expired due to inactivity. ' : 'Submission has expired due to inactivity.The effective date will need to be updated before a new quote can be generated';

        const additionalCoverage = utils.submission.getAdditionalCoverageSelection(
            get(this.props.submission, 'coverages.gl.additional', {
                pollution: { selected: false },
                subsidence: { selected: false },
                extendedCompletedOps: { selected: false }
            }), type, this.props.submission
        );
        this.state = {
            quoteStatus: STATUS.LOADING,
            reasons: [],
            isActiveBrokerage: true,
            isUpdated: false,
            modelTitle: isUnderwriter(this.props.user) ? title : 'Submission has expired due to inactivity. Please re-enter through clearance',
            glBaseCoverage: get(this.props.submission, 'coverages.gl.base', 'standard'),
            glAdditionalCoverage: additionalCoverage,
            glOptionalCoverage: get(this.props.submission, 'coverages.gl.optional', {
                isPCOpsExcluded: { selected: false }
            }),
            quoteCount: 0,
            hasExpired: utils.submission.hasExpired(props.submission.updatedAt),
            manuallySetPricing: props.submission.manuallySetPricing === 'true',
            validationModal: false,
            pricingOptions: utils.submission.getInitialPricingOptionsFields(props.submission.type),
            requiredFields: [],
            showCoverageModel: false,
            preferenceDialogClose: false,
            dialogHeader: 'Please fill out all required fields.',
            submissionUnsaved: undefined,
            referralMessageInDraft: undefined,
        };

        this.handleLoadComplete = this.handleLoadComplete.bind(this);
        this.handleUpsell = this.handleUpsell.bind(this);
        this.handleHideModal = this.handleHideModal.bind(this);
        this.handleRequote = this.handleRequote.bind(this);
        this.handleCoverageChange = this.handleCoverageChange.bind(this);
        this.handleAdditionalCoverageChange = this.handleAdditionalCoverageChange.bind(this);
        this.handleAdditionalInsuredChange = this.handleAdditionalInsuredChange.bind(this);
        this.updateAdditionalInsuredList = this.updateAdditionalInsuredList.bind(this);
        this.handleOptionalCoverageChange = this.handleOptionalCoverageChange.bind(this);
        this.handlePriceInputSelector = this.handlePriceInputSelector.bind(this);
        this.onBlurPriceTextboxHandler = this.onBlurPriceTextboxHandler.bind(this);
        this.handleModalClose = this.handleModalClose.bind(this)
        this.updatePricingOptions = this.updatePricingOptions.bind(this)
        this.validatePricingOptions = this.validatePricingOptions.bind(this)
        this.newReturntoSubmisison = this.newReturntoSubmisison.bind(this);
        this.handleIncludedCoverageChange = this.handleIncludedCoverageChange.bind(this);
        this.handleIncludedCoverageChange = this.handleIncludedCoverageChange.bind(this)
        this.handleBindRequest = this.handleBindRequest.bind(this);
        this.handleBindSaveRequest = this.handleBindSaveRequest.bind(this);
        this.onUnload = this.onUnload.bind(this);
        this.onCreditNotes = this.onCreditNotes.bind(this);
        this.onGCLimitNotes = this.onGCLimitNotes.bind(this);
        this.handleLoadArgopi = this.handleLoadArgopi.bind(this);
    }

    componentWillUnmount() {
        window.removeEventListener("beforeunload", this.onUnload);
    }

    componentWillReceiveProps(nextProps) {
        if(!!this.props.submission && !!this.props.submission.brokerId) {
        const brokerArray = nextProps.brokerages.find(brokerage => this.props.submission.brokerId==brokerage.brokerId)
        const isActiveBrokerage = nextProps.brokerages && nextProps.brokerages.length > 0 ? !!brokerArray : true;
            if(isActiveBrokerage !== this.state.isActiveBrokerage) {
                this.setState({
                    showAgencyAlert: !isActiveBrokerage,
                    isActiveBrokerage,
                    modelTitle: !isActiveBrokerage ? 'The submission is disabled as it belongs to inactive broker company. Please update brokerage in submission details.' : this.state.modelTitle,
                })
            }
        }
        if(this.state.show === undefined && nextProps.brokerages && nextProps.brokerages.length > 0) {
            this.setState({
                show: utils.submission.hasExpired(this.props.submission.updatedAt) ? true : false,
            })
        }
    }

    componentDidMount() {
        if (isEmpty(this.props.submission)) {
            this.props.dispatch(routerActions.push('/login'));
        }

        this.props.dispatch(changeSubmissionStatus(SUBMISSION_STATUS.QUOTE));
        window.addEventListener("beforeunload", this.onUnload);
    }

    onUnload(e) {
        if (this.state.submissionUnsaved === true && this.state.isActiveBrokerage) {
            e.preventDefault();
            e.returnValue = true;
        }
    }

    saveDefaultCoverage(submission) {
        if (submission.type === 'oi' && this.state.quoteCount) {
            const preferences = utils.submission.setPreferences(submission);
            toastify.dismissAll();
            toastify.success(
                preferenceToastMessages.defaultSubmissionMessage(() => {
                    return this.props.dispatch(savePreferences(preferences));
                }),
                { autoClose: 10000 }
            );
        }
    }

    removePreferencesNotification(submission) {
        const { defaultPreference, user: { id } } = this.props;
        if (submission.type === 'oi' && submission.revisionNumber === 0 && defaultPreference) {
            toastify.success(
                preferenceToastMessages.preferenceInfoMsg(() => {
                    return this.props.dispatch(removePreferences(id));
                }),
                { autoClose: 10000 }
            );
        }
    }

    handleLoadComplete(error, response) {
        if (error) {
            toastify.error(toastErrorMessage);
            this.setState({ quoteStatus: STATUS.ERROR });
            return this.props.dispatch(submissionFailed({
                Type: this.props.submission
            }));
        }
        switch (response.result) {
            case 'submission_failed_clearance':
                this.setState({ quoteStatus: STATUS.CLEARANCE });
                break;
            case 'submission_failed_referral_rules_validation':
                this.setState({ quoteStatus: STATUS.KNOCKOUT, reasons: response.data, submissionUnsaved: response.ignoreSaveAndReportGen });
                break;
            case 'submission_saved':
                let submission = response.data;
                this.saveDefaultCoverage(submission);
                this.removePreferencesNotification(submission);
                this.setState({
                    quoteStatus: STATUS.QUOTE,
                    quoteCount: 1 + this.state.quoteCount,
                    submissionUnsaved: response.ignoreSaveAndReportGen,
                    referralMessageInDraft: response.failedReferralRules,
                });
                break;
            case 'submission_drafted':
                submission = response.data;
                this.setState({
                    quoteStatus: STATUS.DRAFT,
                    quoteCount: 1 + this.state.quoteCount,
                    submissionUnsaved: response.ignoreSaveAndReportGen,
                    referralMessageInDraft: response.failedReferralRules
                });
                break;
            default:
                break;
        }


    }

    handleUpsell() {
        const relatedSubmissions = get(this.props.submission, 'relatedEntities.submissions') || [];
        if (relatedSubmissions.length) {
            return relatedSubmissions.forEach(relatedSubmission => {
                this.props.dispatch(editSubmission(relatedSubmission, this.props.user));
            });
        }
        return this.props.dispatch(createRelatedSubmission(this.props.submission, this.props.user));
    }

    handleLoadArgopi(pricingValues) {
        const { submission, defaultPreference } = this.props;
        const { preferenceDialogClose } = this.state;
        submission.hnoaRequired = (!!submission.coverages.gl.additional.hnoaPremium) ?
            submission.coverages.gl.additional.hnoaPremium.selected : submission.hnoaRequired;
        submission.isBankSelected = (!!submission.coverages.gl.additional.bankPremium) ?
            submission.coverages.gl.additional.bankPremium.selected : submission.isBankSelected;
        submission.numberOfBankAIForms = (submission.coverages.gl.additional.additionalInsureds && submission.coverages.gl.additional.additionalInsureds.selected) ||
            !submission.coverages.gl.additional.additionalInsureds ?
            undefined : 0;
        if (submission.additionalInsured == "true" && submission.coverages.gl.additional.additionalInsureds == undefined) {
            submission.coverages.gl.additional.additionalInsureds = { selected: true };
        }
        submission.isPCOpsExcluded = (!!submission.coverages.gl.optional && !!submission.coverages.gl.optional.isPCOpsExcluded) ?
            submission.coverages.gl.optional.isPCOpsExcluded.selected : false;
        submission.isESWorkExcluded = (!!submission.coverages.gl.optional && !!submission.coverages.gl.optional.isESWorkExcluded) ?
            submission.coverages.gl.optional.isESWorkExcluded.selected : false;

        submission.manuallySetPricing = this.state.manuallySetPricing.toString()
    
        if (submission.status !== 'DRAFT') {
            submission.quoteDrafted = 'false';
        }
        submission.formsUpdated = 'true';
        
        const subjectivities = updateSubjectivities(submission, false);
        let u650Exclusions;
        if(submission.type === 'oi'){
            u650Exclusions = updateExclusionU650(submission);
        }
        // Adding manually since the load Argo PI lambda dont make rating call and then save referral rules
        if (this.state.reasons && this.state.reasons.length > 0) {
            let failedReferralRules = [...this.state.reasons];
            Object.assign(
                submission.ratings[submission.type],
                { failedReferralRules }
            )
        }
        Object.assign(
            submission.ratings[submission.type],
            { subjectivities },
            { u650Exclusions },
        )
        const designatedContractors = getItemsNeededToDesignatedContractors(
            submission.ratings[submission.type],
            submission.coverages.gl.base,
            submission.type,
            submission,
            submission.coverages.gl.additional,
            submission.excessLimitAmount
        );
        if ((Array.isArray(designatedContractors) &&
            (designatedContractors.length > 0) ||
            Object.hasOwn(submission.ratings[submission.type], 'designatedContractors'))
        ) {
            Object.assign(
                submission.ratings[submission.type],
                { designatedContractors }
            );
        }
        if ((Array.isArray(designatedContractors) &&
            (designatedContractors.length > 0) ||
            Object.hasOwn(submission.ratings.options, 'designatedContractors'))
        ) {
            Object.assign(
                submission.ratings.options,
                { designatedContractors }
            );
        }
        const u658ContractorName = getU658DesignatedContractorsName(
                submission.ratings[submission.type],
                submission.coverages.gl.base,
                submission.type
        );
        if (
            typeof u658ContractorName === 'string' && 
            (u658ContractorName.length > 0 || Object.hasOwn(submission.ratings[submission.type], 'u658ContractorName'))
        ) {
            Object.assign(
                submission.ratings[submission.type],
                { u658ContractorName }
            );
        }
        if (
            typeof u658ContractorName === 'string' && 
            (u658ContractorName.length > 0 || Object.hasOwn(submission.ratings.options, 'u658ContractorName'))
        ) {
            Object.assign(
                submission.ratings.options,
                { u658ContractorName }
            );
        }

        const requiredFields = this.validatePricingOptions(pricingValues, submission)
        if (requiredFields.length) return;

        const type = submission.type;

        this.props.dispatch({ type: CHANGE_SUBMISSION, payload: { submission } });
        this.props.dispatch(loadArgopi(submission));

    }

    handleRequote(pricingValues, isExcessOnly = false) {
        const { submission, defaultPreference } = this.props;
        const { preferenceDialogClose } = this.state;
        submission.transactionStatus = 'CM';
        submission.hnoaRequired = (!!submission.coverages.gl.additional.hnoaPremium) ?
            submission.coverages.gl.additional.hnoaPremium.selected : submission.hnoaRequired;
        submission.isBankSelected = (!!submission.coverages.gl.additional.bankPremium) ?
            submission.coverages.gl.additional.bankPremium.selected : submission.isBankSelected;
        submission.numberOfBankAIForms = (submission.coverages.gl.additional.additionalInsureds && submission.coverages.gl.additional.additionalInsureds.selected) ||
            !submission.coverages.gl.additional.additionalInsureds ?
            undefined : 0;
        if (submission.additionalInsured == "true" && submission.coverages.gl.additional.additionalInsureds == undefined) {
            submission.coverages.gl.additional.additionalInsureds = { selected: true };
        }
        submission.isPCOpsExcluded = (!!submission.coverages.gl.optional && !!submission.coverages.gl.optional.isPCOpsExcluded) ?
            submission.coverages.gl.optional.isPCOpsExcluded.selected : false;
        submission.isESWorkExcluded = (!!submission.coverages.gl.optional && !!submission.coverages.gl.optional.isESWorkExcluded) ?
            submission.coverages.gl.optional.isESWorkExcluded.selected : false;
        submission.manuallySetPricing = this.state.manuallySetPricing.toString()
        submission.quoteDrafted = 'false';
        submission.isExcessOnly = isExcessOnly;

        const subjectivities = updateSubjectivities(submission, false);
        let u650Exclusions;
        if(submission.type === 'oi'){
            u650Exclusions = updateExclusionU650(submission);
        }
        Object.assign(
            submission.ratings[submission.type],
            { subjectivities },
            { u650Exclusions }
        )
        const designatedContractors = getItemsNeededToDesignatedContractors(
            submission.ratings[submission.type],
            submission.coverages.gl.base,
            submission.type,
            submission,
            submission.coverages.gl.additional,
            submission.excessLimitAmount
        );
        if ((Array.isArray(designatedContractors) &&
            (designatedContractors.length > 0) ||
            Object.hasOwn(submission.ratings[submission.type], 'designatedContractors'))
        ) {
            Object.assign(
                submission.ratings[submission.type],
                { designatedContractors }
            );
        }
        if ((Array.isArray(designatedContractors) &&
            (designatedContractors.length > 0) ||
            Object.hasOwn(submission.ratings.options, 'designatedContractors'))
        ) {
            Object.assign(
                submission.ratings.options,
                { designatedContractors }
            );
        }
        const u658ContractorName = getU658DesignatedContractorsName(
                submission.ratings[submission.type],
                submission.coverages.gl.base,
                submission.type
        );
        if (
            typeof u658ContractorName === 'string' &&
            (u658ContractorName.length > 0 || Object.hasOwn(submission.ratings[submission.type], 'u658ContractorName'))
        ) {
            Object.assign(
                submission.ratings[submission.type],
                { u658ContractorName }
            );
        }
        if (
            typeof u658ContractorName === 'string' &&
            (u658ContractorName.length > 0 || Object.hasOwn(submission.ratings.options, 'u658ContractorName'))
        ) {
            Object.assign(
                submission.ratings.options,
                { u658ContractorName }
            );
        }

        if (
            !isU653Applicable(
                submission.coverages.gl.base,
                submission.type)
        ) {
            if (Object.hasOwn(submission.ratings[submission.type], 'u653Deductible')) {
                delete submission.ratings[submission.type]['u653Deductible'];
            }
            if (Object.hasOwn(submission.ratings.options, 'u653Deductible')) {
                delete submission.ratings.options['u653Deductible'];
            }
            if (Object.hasOwn(submission, 'optionalForms') && Object.hasOwn(submission.optionalForms, 'u653')) {
                delete submission.optionalForms['u653'];
            }
        }

        if (Object.hasOwn(submission, 'optionalForms') && Object.keys(submission.optionalForms).length === 0) {
            delete submission['optionalForms'];
        }

        const requiredFields = this.validatePricingOptions(pricingValues, submission)
        if (requiredFields.length) return;

        const type = submission.type;
        const showAlertPrompt = type == 'oi' && !defaultPreference
        if (!preferenceDialogClose && showAlertPrompt) {
            this.setState({
                showCoverageModel: true
            });
        } else {
            this.setState({
                quoteStatus: STATUS.LOADING,
                reasons: [],
                quoteCount: 1 + this.state.quoteCount
            });

            this.props.dispatch({ type: CHANGE_SUBMISSION, payload: { submission } });
            this.props.dispatch(changeSubmissionStatus(SUBMISSION_STATUS.QUOTE));
        }

    }

    handleAdditionalInsuredChange(index, formValues) {

        let { additionalInsuredArray } = this.props.submission;
        let numberOfAIForms = 0;

        additionalInsuredArray.map((insured, idx) => {
            const keys = Object.keys(insured).reduce((acc, cur) => {
                acc = cur.indexOf('InsuredForms') !== -1 ? cur : acc
                return acc
            }, '');

            if (idx === index && !!keys) {
                if (!insured.noDisplayInMail || insured.noDisplayInMail === false) {
                    (additionalInsuredArray[index])[keys] = formValues;
                    (additionalInsuredArray[index])['approvedForms'] = formValues;
                    numberOfAIForms += !!formValues ? formValues.split(',').length : 0;
                }
            } else {
                if (!insured.noDisplayInMail || insured.noDisplayInMail === false)
                    numberOfAIForms += !!insured[keys] ? insured[keys].split(',').length : 0;
            }
        })
        this.props.dispatch(changeAIFormValues(additionalInsuredArray, index, formValues, numberOfAIForms));
        this.props.dispatch(changePricingValue({ additionalInsureds: (250 * numberOfAIForms) }))
    }

    updateAdditionalInsuredList(event) {

        let { additionalInsuredArray } = this.props.submission;
        let idx = '';
        let removedForms = '';
        const insKeys = ['additionalInsuredName', 'secondAdditionalInsuredName', 'thirdAdditionalInsuredName'];
        let selectedAI = [];
        event.map((obj) => {
            selectedAI = [...selectedAI, obj.label];
        })
        additionalInsuredArray.map((insured, index) => {
            const insFormKeys = ['additionalInsuredForms', 'secondAdditionalInsuredForms', 'thirdAdditionalInsuredForms'];
            if (selectedAI.includes(insured[insKeys[index]])) {
                insured.noDisplayInMail = false;
            } else {
                idx = index;
                removedForms = insured[insFormKeys[index]];
                insured.noDisplayInMail = true;
            }
        });
        const numberOfInsureds = event.length
        this.props.dispatch(changeAIList(additionalInsuredArray, numberOfInsureds));
        this.handleAdditionalInsuredChange(idx, removedForms);
    }

    handleAdditionalCoverageChange(evt, value) {
        const { target } = evt;
        // handle pricing values
        const selectedOptions = Object.keys(value)
        if (selectedOptions.includes(target.name)) {
            this.props.dispatch(changePricingValue({ [target.dataset.optionKey]: Number(target.dataset.optionText.replace(/[$,+]/g, '')) }))
        } else {
            this.props.dispatch(changePricingValue({ [target.dataset.optionKey]: 0 }))
        }
        Object.assign(this.props.submission, { hnoaRequired: selectedOptions.includes('hnoaPremium') });
        Object.assign(this.props.submission, { isBankSelected: selectedOptions.includes('bankPremium') });
        Object.assign(this.props.submission.coverages.gl.additional, value)
        const changeType = target.checked ? 'Add' : 'Remove';

        this.setState({ glAdditionalCoverage: value }, () => {
            this.props.dispatch(
                changeCoverage({
                    submission: this.props.submission,
                    selectionType: 'Additional',
                    selectionAction: changeType,
                    selectedValue: target.name
                })
            );
        });
        this.props.dispatch(updateWorkflowStatusChange(this.props.submission));
    }

    handleIncludedCoverageChange(included) {
        this.props.dispatch(updateWorkflowIncludedChange(included))
    }

    handleOptionalCoverageChange(evt, value) {
        const { target } = evt;
        // handle pricing values
        let defaultKeyValue = 0;

        let objSubmission = this.props.submission;
        const selectedOptions = Object.keys(value)
        if (target.name === "isPCOpsExcluded") {
            objSubmission.isPCOpsExcluded = evt.target.checked;
            if (!!objSubmission.coverages.gl.additional.extendedCompletedOps) objSubmission.coverages.gl.additional.extendedCompletedOps.selected = false;
            this.props.dispatch({ type: CHANGE_SUBMISSION, payload: { objSubmission } });
        } else if (target.name === "isESWorkExcluded") {
            objSubmission.isESWorkExcluded = evt.target.checked;
            this.props.dispatch({ type: CHANGE_SUBMISSION, payload: { objSubmission } });
        } else if (selectedOptions.includes(target.name)) {
            this.props.dispatch(changePricingValue({ [target.dataset.optionKey]: Number(target.dataset.optionText.replace(/[$,+]/g, '')) }))
        } else {
            this.props.dispatch(changePricingValue({ [target.dataset.optionKey]: defaultKeyValue }))
        }

        const changeType = target.checked ? 'Add' : 'Remove';

        this.setState({ glOptionalCoverage: value }, () => {
            this.props.dispatch(
                changeCoverage({
                    submission: objSubmission,
                    selectionType: 'Optional',
                    selectionAction: changeType,
                    selectedValue: target.name
                })
            );
        });
    }

    closeCoverageModelAndRequote = () => {
        this.setState(
            {
                showCoverageModel: false,
                preferenceDialogClose: true,
            },
            () => {
                this.handleRequote();
            }
        );
    }

    handleCoverageChange(evt, value) {
        const updatedSubmission = this.props.submission;
        if (value === 'deductibleWarranty' && !updatedSubmission.isDeductibleWarranty) {
            Object.assign(updatedSubmission, {isDeductibleWarranty : true});
        } else if (updatedSubmission.isDeductibleWarranty && value != 'deductibleWarranty') {
            delete updatedSubmission.isDeductibleWarranty;
        }
        this.props.dispatch({ type: CHANGE_SUBMISSION, payload: { submission: updatedSubmission } });
        // handle coverage values
        if (evt) {
            this.props.dispatch(changePricingValue({ basePremium: Number(evt.target.dataset.optionText.replace(/[$,+]/g, '')) }))
        }

        this.setState(
            {
                glBaseCoverage: value
            },
            () => {
                this.props.dispatch(
                    changeCoverage({
                        submission: updatedSubmission,
                        selectionType: 'Base',
                        selectionAction: 'Change to',
                        selectedValue: value
                    })
                );
            }
        );
    }

    handleHideModal() {
        this.setState({
            show: false,
            modelTitle: ''
        })
    }

    handlePriceInputSelector(event, selectedValue) {
        const manuallySetPricing = selectedValue === 'manuallySetPricing'
        this.setState({ manuallySetPricing })
    }

    onBlurPriceTextboxHandler(priceValue) {
        this.props.dispatch(changePricingValue(priceValue))
    }

    handleBindRequest(submission) {
        this.props.dispatch((updatedIsBinded(submission)));
    }

    handleBindSaveRequest(submission) {
        this.props.dispatch((updatedIsBinderSaved(submission)));
    }

    onCreditNotes(comment) {
        const { submission } = this.props;
        Object.assign(submission, {'onCreditNotes': comment})
        this.props.dispatch({ type: CHANGE_SUBMISSION, payload: { submission } });
    }

    onGCLimitNotes(comment) {
        const { submission } = this.props;
        Object.assign(submission, {'onGCLimitNotes': comment})
        this.props.dispatch({ type: CHANGE_SUBMISSION, payload: { submission } });
    }

    handleApiCall = (updatedAt) => {
        this.setState({
            isUpdated: true,
            show: utils.submission.hasExpired(updatedAt)
        })

    }

    renderLoadingComponent() {
        return (
            <Loading
                handleSubmit={this.handleLoadComplete}
                submission={this.props.submission}
                quoteCount={this.state.quoteCount}
                person={this.props.person}
                handleApiCall={(updatedAt) => this.handleApiCall(updatedAt)}
            />
        );
    }

    renderErrorComponent() {
        return <Error />;
    }

    newReturntoSubmisison() {
        this.redirectToSubmission();
    }

    renderQuoteComponent() {
        const { submission } = this.props;
        return (
            <Quote
                submission={submission}
                quoteStatus={this.state.quoteStatus}
                handleUpsell={this.handleUpsell}
                handleRequote={this.handleRequote}
                handleCoverageChange={this.handleCoverageChange}
                handleAdditionalCoverageChange={this.handleAdditionalCoverageChange}
                handleAdditionalInsuredChange={this.handleAdditionalInsuredChange}
                handleOptionalCoverageChange={this.handleOptionalCoverageChange}
                clearSubmissionStatus={clearSubmissionStatus}
                manuallySetPricing={this.state.manuallySetPricing}
                handlePriceInputSelector={this.handlePriceInputSelector}
                onBlurPriceTextboxHandler={this.onBlurPriceTextboxHandler}
                updatePricingOptions={this.updatePricingOptions}
                returntoSubmission={this.newReturntoSubmisison}
                handleIncludedCoverageChange={this.handleIncludedCoverageChange}
                updateAdditionalInsuredList={this.updateAdditionalInsuredList}
                handleBindRequest={this.handleBindRequest}
                handleBindSaveRequest={this.handleBindSaveRequest}
                isActiveBrokerage={this.state.isActiveBrokerage}
                onCreditNotes={this.onCreditNotes}
                onGCLimitNotes={this.onGCLimitNotes}
                handleLoadArgopi={this.handleLoadArgopi}
                quoteUnsaved={this.state.submissionUnsaved}
                referralMessageInDraft={this.state.referralMessageInDraft}
            />
        );
    }

    renderKnockoutComponent() {
        return (
            <Knockout
                submission={this.props.submission}
                reasons={this.state.reasons}
                underwriters={this.props.contactUnderWriter}
                user={this.props.user}
                handleUpsell={this.handleUpsell}
                handleRequote={this.handleRequote}
                handleCoverageChange={this.handleCoverageChange}
                handleAdditionalCoverageChange={this.handleAdditionalCoverageChange}
                handleOptionalCoverageChange={this.handleOptionalCoverageChange}
                handleAdditionalInsuredChange={this.handleAdditionalInsuredChange}
                updateAdditionalInsuredList={this.updateAdditionalInsuredList}
                manuallySetPricing={this.state.manuallySetPricing}
                handlePriceInputSelector={this.handlePriceInputSelector}
                onBlurPriceTextboxHandler={this.onBlurPriceTextboxHandler}
                updatePricingOptions={this.updatePricingOptions}
                isActiveBrokerage={this.state.isActiveBrokerage}
                onCreditNotes={this.onCreditNotes}
                onGCLimitNotes={this.onGCLimitNotes}
                returntoSubmission={this.newReturntoSubmisison}
                handleLoadArgopi={this.handleLoadArgopi}
                referralUnsaved={this.state.submissionUnsaved}
            />
        );
    }

    renderClearanceComponent() {
        return (
            <PendingStatus
                submission={this.props.submission}
                user={this.props.user}
                handleUpsell={this.handleUpsell}
                handleRequote={this.handleRequote}
                handleCoverageChange={this.handleCoverageChange}
                handleAdditionalCoverageChange={this.handleAdditionalCoverageChange}
                handleOptionalCoverageChange={this.handleOptionalCoverageChange}
                handleAdditionalInsuredChange={this.handleAdditionalInsuredChange}
                updateAdditionalInsuredList={this.updateAdditionalInsuredList}
                manuallySetPricing={this.state.manuallySetPricing}
                handlePriceInputSelector={this.handlePriceInputSelector}
                onBlurPriceTextboxHandler={this.onBlurPriceTextboxHandler}
                updatePricingOptions={this.updatePricingOptions}
                isActiveBrokerage={this.state.isActiveBrokerage}
                onCreditNotes={this.onCreditNotes}
                onGCLimitNotes={this.onGCLimitNotes}
                returntoSubmission={this.newReturntoSubmisison}
                handleLoadArgopi={this.handleLoadArgopi}
            />
        );
    }

    redirectToSubmission = () => {
        this.setState({
            showAgencyAlert: false,
            show: false,
        })
        if(this.state.isActiveBrokerage) {
            this.props.dispatch(routerActions.push('/submissions'))
        }
    };
    redirectToQuote = (id) => this.props.dispatch(routerActions.push(`/quote/${id}/false`));

    renderPreferenceDialog = () => {
        const { submission, defaultPreference } = this.props;
        const { preferenceDialogClose, showCoverageModel } = this.state;
        const showAlertPrompt = submission.type == 'oi' && !defaultPreference
        const title = preferenceDialogClose ? "Are these your preferred options?" : "You can set and update these any time"
        return ((showAlertPrompt || preferenceDialogClose) &&
            <DialogBox
                custom_class="cancelDialog"
                title={title}
                show={showCoverageModel}
                onHide={this.closeCoverageModelAndRequote}
            >
                {!preferenceDialogClose && (
                    <div>
                        <p>Your quote is on the way. You can save these forms and coverage selection as your default for the future. (You can always change this later).</p>
                        <ButtonGroup>
                            <Button
                                className="btn"
                                onClick={() => {
                                    const preferences = utils.submission.setPreferences(submission);
                                    this.props.dispatch(savePreferences(preferences));
                                    this.closeCoverageModelAndRequote()
                                }}>
                                Save as Default
                            </Button>
                            <Button className="btn secondary" onClick={this.doNotSetPreference}>Do not set preferences</Button>
                        </ButtonGroup>
                    </div>
                )}
                {preferenceDialogClose && (
                    <div>
                        <p>We won't prompt you again, but you can utilize the notification to set these values after selecting new coverage.</p>
                        <ButtonGroup>
                            <Button onClick={this.closeCoverageModelAndRequote}>Thanks!</Button>
                        </ButtonGroup>
                    </div>
                )}
            </DialogBox >
        )
    }

    doNotSetPreference = () => {
        const { id } = this.props.user;
        const { type } = this.props.submission;
        this.setState(
            {
                preferenceDialogClose: true
            },
            () => {
                this.props.dispatch(doNotSetPreference({
                    id,
                    product_defaults: {
                        [type]: {
                            skipPreferencesAlert: true
                        }
                    }
                }));
            }
        );
    }

    renderGoBackButton() {
        let url = window.location.href;
        let quote_id = url.substring(url.lastIndexOf('/') + 1);
        return (
            <div>
                <Button
                    bsStyle="link"
                    onClick={routerActions.goBack}
                    className="buttonBack"
                >
                    <LinkContainer className="glyphicon glyphicon-arrow-left reduce-space" to={`/submission/${quote_id}`}>
                        <span>Back to Submission Details</span>
                    </LinkContainer>
                </Button>
            </div>
        )
    }

    updatePricingOptions(options) {
        const { pricingOptions } = this.state
        options.map(option => {
            const index = pricingOptions.findIndex((pricingOption) => pricingOption.key === option.key)
            if (index !== -1) {
                pricingOptions[index].required = !!(option.selected || option.required)
                pricingOptions[index].label = option.label
            } else {
                pricingOptions.push({
                    key: option.key,
                    required: !!(option.selected || option.required),
                    label: option.label
                })
            }
        })
        if (this.state.pricingOptions !== pricingOptions) {
            this.setState({ pricingOptions });
        }
    }

    validatePricingOptions(pricingValues, submission) {
        const requiredFields = []
        const validations = validation.execute(submission, this.props.person.isUnderwriter, this.props.submission.type);
        let includedValidations = [];

        if (submission.included) {
            submission.included.map((value) => {
                if (value.includes("Premium") == false) {
                    includedValidations.push(value.concat("Premium"))
                } else {
                    includedValidations.push(value);
                }
            })
        }
        validations.map((validation) => {
            requiredFields.push(validation.text)
            if (validation.name.startsWith('additional') || validation.name.startsWith('secondAdditional')
                || validation.name.startsWith('thirdAdditional')) {
                this.setState({
                    dialogHeader: 'New additional insured feature requires below information, please re-visit your submission details'
                })
            }
            if(validation.name.startsWith('structuralWork') || validation.name.startsWith('demolition') || validation.name.startsWith('projectRequirements')
            || validation.name.startsWith('updateAdditionalInsured')){
                this.setState({
                    dialogHeader: 'Latest application update requires below information, please re-visit your submission details.'
                })
            }
            else {
                this.setState({
                    dialogHeader: 'Please fill out all required fields.'
                })
            }
        })
        if (isUnderwriter(this.props.user) && this.state.manuallySetPricing) {
            /**
             * Some Additional Coverages can be eligible for no additional premium. So we need
             * to allow $0 for Manual Premium (and System Generated as well)
             **/
            const noAddlPremEligibleCovgs =  [
                'subsidencePremium',
                'extendedCompletedOpsPremium',
                'pollutionPremium'
            ];
            const { pricingOptions } = this.state
            if (submission.type === 'oi') {
                if (submission.ratings.oi.bankPremium <= 0) {
                    pricingOptions[10].required = false;
                }
                if (submission.ratings.oi.additionalInsureds <= 0) {
                    pricingOptions[11].required = false;
                }
            }
            pricingOptions.map((option) => {
                let price = String(get(pricingValues, option.key, 0)).replace(/[$,+]/g, '')
                price = price ? Number(price) : 0
                if (noAddlPremEligibleCovgs.includes(option.key)) {
                    if (option.required && Number.isNaN(price)) {
                        requiredFields.push(option.label)
                    }
                } else if (option.required && (price === 0 || isNaN(price))) {
                    requiredFields.push(option.label)
                }
                if (option.label == "Product Completed Operations") {
                    const index = requiredFields.indexOf("Extended Product Completed Operations");
                    if (index > -1) {
                        requiredFields.splice(index, 1);
                    }
                }
                if (option.label == "Structural/Exterior Work") {
                    const index = requiredFields.indexOf("Extended Product Completed Operations");
                    if (index > -1) {
                        requiredFields.splice(index, 1);
                    }
                }
                if ((includedValidations.length > 0 && includedValidations.includes(option.key)) || (option.label == "Product Completed Operations")|| (option.label == 'Structural/Exterior Work')) {
                    const index = requiredFields.indexOf(option.label);
                    if (index > -1) {
                        requiredFields.splice(index, 1);
                    }
                }
            })
        }
        if (requiredFields.length) {
            this.setState({ validationModal: true, requiredFields })
        }
        return requiredFields
    }
    handleModalClose() {
        this.setState({
            validationModal: false
        });
    }

    render() {
        if (isEmpty(this.props.submission)) {
            return null;
        }
        const requiredFieldsList = () => {
            return this.state.requiredFields.map((field, index) => {
                return (
                    <li key={index} className="remainingField">
                        {field}
                    </li>
                );
            });
        }

        return (
            <div className="formResults routeContainer">
                <Prompt
                    when={(this.state.quoteStatus === 'DRAFT' || this.state.submissionUnsaved === true) && this.state.isActiveBrokerage }
                    message={location =>
                        `Quote not submitted. Do you want to continue?`
                    }
                />
                <div className="container">
                    {this.renderGoBackButton()}
                    {this.state.quoteStatus === 'LOADING' && this.renderLoadingComponent()}
                    {this.state.quoteStatus === 'ERROR' && this.renderErrorComponent()}
                    {(this.state.quoteStatus === 'QUOTE' || this.state.quoteStatus === 'DRAFT') && this.renderQuoteComponent()}
                    {this.state.quoteStatus === 'KNOCKOUT' && this.renderKnockoutComponent()}
                    {this.state.quoteStatus === 'CLEARANCE' && this.renderClearanceComponent()}
                    {this.state.showCoverageModel && this.renderPreferenceDialog()}
                </div>
                <DialogBox
                    title={this.state.modelTitle}
                    show={this.state.quoteStatus === 'LOADING' ? (this.state.isUpdated && this.state.show) : (this.state.show || this.state.showAgencyAlert)}
                    onHide={this.redirectToSubmission}
                >
                    {this.state.isActiveBrokerage ? (this.state.hasExpired && (isUnderwriter(this.props.user)) ? <Button onClick={this.handleHideModal}>Continue</Button> : <Button onClick={this.redirectToSubmission}>Return to Submissions</Button>) : ''}
                </DialogBox>
                {this.state.showCoverageModel && this.renderPreferenceDialog()}
                <DialogBox
                    custom_class="confirmationDialog"
                    title={this.state.dialogHeader}
                    show={this.state.validationModal}
                    onHide={this.handleModalClose}
                >
                    <div>
                        <h4>Here are your remaining fields:</h4>
                        <ul className="section">{requiredFieldsList()}</ul>

                        <br />

                        <ButtonGroup>
                            <Button className="btn" onClick={this.handleModalClose}>
                                Return
                            </Button>
                        </ButtonGroup>
                    </div>
                </DialogBox>
            </div>
        );
    }
}

FormResults.propTypes = {
    submission: PropTypes.object,
    clearSubmissionStatus: PropTypes.func,
    dispatch: PropTypes.func.isRequired
};

const mapStateToProps = state => {
    return {
        defaultPreference: state.user.defaultPreference,
        person: state.person,
        user: state.user,
        contactUnderWriter: state.auth.contactUnderWriter,
        brokerages: state.brokerages.items,
    };
};

const connectedFormResults = connect(mapStateToProps)(FormResults);
export default withSubmission(connectedFormResults);
